import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Catalog from '../Catalog';
import { COUPON } from '../CatalogList';
import { EventSectionProps } from '../../AdminClasses';
import { useUser } from '../../AdminHooks';

var EventPromotions = (props: EventSectionProps)=>{
	var { t } = useTranslation();
	var { user, hasAccess } = useUser();
	useEffect(()=>{
		
	}, []);
	
	return <div>
		<Catalog options={COUPON(user, hasAccess, props.event.event_id)} titleSize={'small'} style={{
			maxWidth: 700
		}} />
	</div>
}

export default EventPromotions;